import { registerEvent } from '@/services/messaging/clientEventMethods';

export const twoFactorAuthenticationDisabledEvent$ = registerEvent("TwoFactorAuthenticationDisabledEvent");
export const twoFactorAuthenticationNotDisabledEvent$ = registerEvent("TwoFactorAuthenticationNotDisabledEvent");
export const twoFactorAuthenticationEnabledEvent$ = registerEvent("TwoFactorAuthenticationEnabledEvent");
export const twoFactorAuthenticationNotEnabledEvent$ = registerEvent("TwoFactorAuthenticationNotEnabledEvent")

export const transferredCustomerWithdrawnEvent$ = registerEvent("TransferredCustomerWithdrawnEvent");
export const transferredCustomerEvent$ = registerEvent("TransferredCustomerEvent");
